<template>
  <div>
  <ai-tab-nav />
  <div class="ai-check-item-page">
    <page-header title="AI 检查项管理" :count="total">
      <template #actions>
        <el-tag v-if="filter.ruleCode" type="info" size="small">规则 {{ filter.ruleCode }}</el-tag>
        <el-button v-if="filter.ruleCode" type="text" size="mini" icon="el-icon-back" @click="backToRule">返回规则库</el-button>
        <el-button size="small" icon="el-icon-plus" type="success" @click="openDialog(null)">新增</el-button>
        <el-button size="small" icon="el-icon-view" @click="openPromptPreview">预览 Prompt</el-button>
      </template>
      <el-input v-model="filter.ruleCode" placeholder="规则编号 R002" clearable size="small" @keyup.enter.native="loadList" />
      <el-select v-model="filter.sceneCode" placeholder="场景" clearable size="small" @change="loadList">
        <el-option label="供应商" value="supplier" />
        <el-option label="劳务" value="labor" />
        <el-option label="合同" value="contract" />
      </el-select>
      <el-select v-model="filter.feeType" placeholder="费用类型" clearable filterable size="small" @change="loadList">
        <el-option v-for="o in feeTypeOptions" :key="o.id" :label="o.dictLabel" :value="o.dictLabel" />
      </el-select>
      <el-select v-model="filter.checkType" placeholder="检查类型" clearable size="small" @change="loadList">
        <el-option label="金额(amount)" value="amount" />
        <el-option label="盖章(seal)" value="seal" />
        <el-option label="日期(date)" value="date" />
        <el-option label="内容(content)" value="content" />
        <el-option label="格式(format)" value="format" />
        <el-option label="照片(photo)" value="photo" />
        <el-option label="其他(other)" value="other" />
      </el-select>
      <el-select v-model="filter.severity" placeholder="严重度" clearable size="small" @change="loadList">
        <el-option label="FAIL" value="FAIL" />
        <el-option label="WARN" value="WARN" />
        <el-option label="INFO" value="INFO" />
      </el-select>
      <el-select v-model="filter.enabled" placeholder="状态" clearable size="small" @change="loadList">
        <el-option label="启用" :value="1" />
        <el-option label="禁用" :value="0" />
      </el-select>
      <el-button size="small" icon="el-icon-search" type="primary" @click="loadList">查询</el-button>
    </page-header>

    <!-- 批量操作 -->
    <div class="batch-bar" v-if="selectedIds.length > 0">
      <span>已选 {{ selectedIds.length }} 项</span>
      <el-button size="mini" type="success" @click="batchToggle(true)">批量启用</el-button>
      <el-button size="mini" type="warning" @click="batchToggle(false)">批量禁用</el-button>
    </div>

    <el-table :data="list" v-loading="loading" stripe border size="small" class="app-table"
      @selection-change="onSelectionChange" style="width:100%">
      <el-table-column type="selection" width="42" />
      <el-table-column prop="itemCode" label="检查项编号" width="110" />
      <el-table-column prop="ruleCode" label="所属规则" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="mini" type="info">{{ row.ruleCode }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="itemName" label="检查项名称" min-width="200" show-overflow-tooltip />
      <el-table-column prop="feeType" label="费用类型" width="100" align="center">
        <template slot-scope="{ row }">{{ row.feeType || '-' }}</template>
      </el-table-column>
      <el-table-column prop="docType" label="文档类型" width="100" align="center">
        <template slot-scope="{ row }">{{ row.docType || '-' }}</template>
      </el-table-column>
      <el-table-column prop="checkType" label="检查类型" width="100" align="center">
        <template slot-scope="{ row }">
          <el-tag size="mini" v-if="row.checkType">{{ row.checkType }}</el-tag>
          <span v-else style="color:#bbb">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="severity" label="严重度" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="severityType(row.severity)">{{ row.severity }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="enabled" label="启用" width="70" align="center">
        <template slot-scope="{ row }">
          <el-switch :value="row.enabled === 1" @change="onToggle(row, $event)" />
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" align="center" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" size="small" @click="openDialog(row)">编辑</el-button>
          <el-button type="text" size="small" @click="handleDuplicate(row)">复制</el-button>
          <el-button type="text" size="small" style="color:#F56C6C" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="app-pagination">
      <el-pagination
        background
        layout="prev, pager, next, total"
        :total="total"
        :current-page.sync="page.pageNum"
        :page-size="page.pageSize"
        @current-change="loadList" />
    </div>

    <!-- 编辑弹窗 -->
    <el-dialog :title="editForm.id ? '编辑检查项' : '新增检查项'" :visible.sync="dialogVisible" width="640px" append-to-body>
      <el-form :model="editForm" label-width="100px" :rules="rules" ref="editFormRef" size="small">
        <el-form-item label="所属规则ID" prop="ruleId">
          <el-input-number v-model="editForm.ruleId" :min="1" :disabled="!!editForm.id" />
          <span style="margin-left:8px;color:#999;font-size:12px">规则的数据库ID,不是 ruleCode</span>
        </el-form-item>
        <el-form-item label="规则编号" prop="ruleCode">
          <el-input v-model="editForm.ruleCode" placeholder="如 R002" />
        </el-form-item>
        <el-form-item label="检查项编号" prop="itemCode">
          <el-input v-model="editForm.itemCode" placeholder="如 R002-09" :disabled="!!editForm.id" />
        </el-form-item>
        <el-form-item label="检查项名称" prop="itemName">
          <el-input v-model="editForm.itemName" placeholder="检查点的简短描述" />
        </el-form-item>
        <el-form-item label="检查内容" prop="checkContent">
          <el-input v-model="editForm.checkContent" type="textarea" :rows="4"
            placeholder="自然语言,会被拼进 LLM 的 Prompt。写得越清晰,LLM 判断越准。" />
        </el-form-item>
        <el-form-item label="场景">
          <el-select v-model="editForm.sceneCode" style="width:100%">
            <el-option label="供应商" value="supplier" />
            <el-option label="劳务" value="labor" />
            <el-option label="合同" value="contract" />
          </el-select>
        </el-form-item>
        <el-form-item label="费用类型">
          <el-select v-model="editForm.feeType" filterable clearable allow-create placeholder="留空表示通用;可下拉选择或手工输入" style="width:100%">
            <el-option v-for="o in feeTypeOptions" :key="o.id" :label="o.dictLabel" :value="o.dictLabel" />
          </el-select>
        </el-form-item>
        <el-form-item label="文档类型">
          <el-select v-model="editForm.docType" filterable clearable allow-create placeholder="可下拉选择或手工输入" style="width:100%">
            <el-option v-for="o in docTypeOptions" :key="o.id" :label="o.dictLabel" :value="o.dictLabel" />
          </el-select>
        </el-form-item>
        <el-form-item label="检查类型">
          <el-select v-model="editForm.checkType" clearable style="width:100%">
            <el-option label="金额 amount" value="amount" />
            <el-option label="盖章 seal" value="seal" />
            <el-option label="日期 date" value="date" />
            <el-option label="内容 content" value="content" />
            <el-option label="格式 format" value="format" />
            <el-option label="照片 photo" value="photo" />
            <el-option label="其他 other" value="other" />
          </el-select>
        </el-form-item>
        <el-form-item label="严重度">
          <el-radio-group v-model="editForm.severity">
            <el-radio-button label="FAIL">FAIL</el-radio-button>
            <el-radio-button label="WARN">WARN</el-radio-button>
            <el-radio-button label="INFO">INFO</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="优先级">
          <el-input-number v-model="editForm.priority" :min="0" :max="999" />
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="editFormEnabled" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="saving" @click="handleSave">保存</el-button>
      </div>
    </el-dialog>

    <!-- Prompt 预览弹窗 -->
    <el-dialog title="Prompt 预览" :visible.sync="promptVisible" width="800px" append-to-body>
      <el-form inline size="small">
        <el-form-item label="场景">
          <el-select v-model="previewScene" style="width:120px">
            <el-option label="供应商" value="supplier" />
            <el-option label="劳务" value="labor" />
            <el-option label="合同" value="contract" />
          </el-select>
        </el-form-item>
        <el-form-item label="费用类型">
          <el-select v-model="previewFeeTypes" multiple style="width:380px" placeholder="留空 = 仅全局规则">
            <el-option v-for="o in feeTypeOptions" :key="o.id" :label="o.dictLabel" :value="o.dictLabel" />
          </el-select>
        </el-form-item>
        <el-button type="primary" size="small" @click="doPreview" :loading="previewing">生成预览</el-button>
        <el-button v-if="previewContent" size="small" icon="el-icon-document-copy" @click="copyPrompt">复制</el-button>
      </el-form>
      <div v-if="previewContent">
        <div style="margin:8px 0;color:#999;font-size:13px">
          字符数: {{ previewLength }}
        </div>
        <pre class="prompt-pre">{{ previewContent }}</pre>
      </div>
      <div slot="footer">
        <el-button size="small" @click="promptVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { aiCheckItemApi, aiDictApi } from './api.js';
import AiTabNav from './AiTabNav.vue';
import PageHeader from '@/components/PageHeader.vue';

const SEVERITY_TYPE = { FAIL: 'danger', WARN: 'warning', INFO: 'info' };

export default {
  name: 'AiCheckItemManage',
  components: { AiTabNav, PageHeader },
  data() {
    return {
      list: [],
      loading: false,
      saving: false,
      total: 0,
      page: { pageNum: 1, pageSize: 10 },
      filter: { ruleId: null, ruleCode: '', sceneCode: '', feeType: '', checkType: '', severity: '', enabled: null },
      selectedIds: [],
      dialogVisible: false,
      editForm: this.emptyForm(),
      rules: {
        ruleId: [{ required: true, message: 'ruleId 必填', trigger: 'blur' }],
        ruleCode: [{ required: true, message: 'ruleCode 必填', trigger: 'blur' }],
        itemCode: [{ required: true, message: 'itemCode 必填', trigger: 'blur' }],
        itemName: [{ required: true, message: '名称必填', trigger: 'blur' }],
        checkContent: [{ required: true, message: '检查内容必填', trigger: 'blur' }]
      },
      // Prompt 预览
      promptVisible: false,
      previewing: false,
      previewScene: 'supplier',
      previewFeeTypes: [],
      previewContent: '',
      previewLength: 0,
      feeTypeOptions: [],
      docTypeOptions: []
    };
  },
  computed: {
    editFormEnabled: {
      get() { return this.editForm.enabled === 1; },
      set(v) { this.editForm.enabled = v ? 1 : 0; }
    }
  },
  created() {
    // 加载字典
    this.loadDicts();
    // 从路由参数(规则页跳过来)读 ruleId
    if (this.$route.query.ruleId) {
      this.filter.ruleId = parseInt(this.$route.query.ruleId);
      this.filter.ruleCode = this.$route.query.ruleCode || '';
    }
    this.loadList();
  },
  methods: {
    /** 加载字典 */
    async loadDicts() {
      try {
        const [feeResp, docResp] = await Promise.all([
          aiDictApi.options('fee_type'),
          aiDictApi.options('doc_type')
        ]);
        if (feeResp.code === 200) this.feeTypeOptions = feeResp.data || [];
        if (docResp.code === 200) this.docTypeOptions = docResp.data || [];
      } catch (e) { /* 不阻断 */ }
    },
    severityType(s) { return SEVERITY_TYPE[s] || ''; },

    emptyForm() {
      return {
        id: null, ruleId: null, ruleCode: '', itemCode: '', itemName: '',
        checkContent: '', sceneCode: 'supplier', feeType: '', docType: '',
        checkType: '', severity: 'FAIL', enabled: 1, priority: 100
      };
    },

    async loadList() {
      this.loading = true;
      try {
        const params = {
          pageNum: this.page.pageNum, pageSize: this.page.pageSize,
          ...this.filter
        };
        Object.keys(params).forEach(k => { if (params[k] === '' || params[k] === null) delete params[k]; });
        const resp = await aiCheckItemApi.page(params);
        if (resp.code === 200) {
          this.list = resp.data.records || [];
          this.total = resp.data.total || 0;
        } else {
          this.$message.error(resp.msg || '查询失败');
        }
      } catch (e) {
        this.$message.error('网络错误');
      } finally {
        this.loading = false;
      }
    },

    backToRule() {
      this.$router.push({ name: 'aiRule' });
    },

    onSelectionChange(rows) {
      this.selectedIds = rows.map(r => r.id);
    },

    openDialog(row) {
      if (row) {
        this.editForm = { ...row };
      } else {
        this.editForm = this.emptyForm();
        // 如果当前过滤了某规则,自动填入 ruleId/ruleCode
        if (this.filter.ruleId) {
          this.editForm.ruleId = this.filter.ruleId;
          this.editForm.ruleCode = this.filter.ruleCode;
        }
      }
      this.dialogVisible = true;
      this.$nextTick(() => this.$refs.editFormRef && this.$refs.editFormRef.clearValidate());
    },

    handleSave() {
      this.$refs.editFormRef.validate(async valid => {
        if (!valid) return;
        this.saving = true;
        try {
          const fn = this.editForm.id
            ? aiCheckItemApi.update(this.editForm.id, this.editForm)
            : aiCheckItemApi.create(this.editForm);
          const resp = await fn;
          if (resp.code === 200) {
            this.$message.success('保存成功 (缓存已自动失效)');
            this.dialogVisible = false;
            this.loadList();
          } else {
            this.$message.error(resp.msg || '保存失败');
          }
        } catch (e) {
          this.$message.error('网络错误');
        } finally {
          this.saving = false;
        }
      });
    },

    handleDelete(row) {
      this.$confirm(`确认删除 ${row.itemCode}「${row.itemName}」?`, '提示', { type: 'warning' })
        .then(async () => {
          const resp = await aiCheckItemApi.remove(row.id);
          if (resp.code === 200) {
            this.$message.success('已删除');
            this.loadList();
          } else {
            this.$message.error(resp.msg || '删除失败');
          }
        }).catch(() => {});
    },

    async handleDuplicate(row) {
      try {
        const resp = await aiCheckItemApi.duplicate(row.id);
        if (resp.code === 200) {
          this.$message.success(`已复制 → ${resp.data.itemCode}`);
          this.loadList();
        } else {
          this.$message.error(resp.msg || '复制失败');
        }
      } catch (e) {
        this.$message.error('网络错误');
      }
    },

    async onToggle(row, value) {
      const resp = await aiCheckItemApi.toggle(row.id, value);
      if (resp.code === 200) {
        row.enabled = value ? 1 : 0;
        this.$message.success(value ? '已启用' : '已禁用');
      } else {
        this.$message.error(resp.msg || '操作失败');
      }
    },

    async batchToggle(enabled) {
      this.$confirm(`确认批量${enabled ? '启用' : '禁用'} ${this.selectedIds.length} 个检查项?`,
        '提示', { type: 'warning' }).then(async () => {
        const resp = await aiCheckItemApi.batchToggle(this.selectedIds, enabled);
        if (resp.code === 200) {
          this.$message.success(`已批量${enabled ? '启用' : '禁用'}`);
          this.loadList();
        } else {
          this.$message.error(resp.msg || '操作失败');
        }
      }).catch(() => {});
    },

    openPromptPreview() {
      this.previewContent = '';
      this.previewLength = 0;
      this.previewVisible = true;
      this.promptVisible = true;
    },

    async doPreview() {
      this.previewing = true;
      try {
        const resp = await aiCheckItemApi.previewPrompt(this.previewScene, this.previewFeeTypes);
        if (resp.code === 200) {
          this.previewContent = resp.data.systemPrompt || '';
          this.previewLength = resp.data.length || 0;
        } else {
          this.$message.error(resp.msg || '生成失败');
        }
      } catch (e) {
        this.$message.error('网络错误');
      } finally {
        this.previewing = false;
      }
    },

    copyPrompt() {
      // 简单 fallback
      const ta = document.createElement('textarea');
      ta.value = this.previewContent;
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy');
        this.$message.success('已复制到剪贴板');
      } catch (e) {
        this.$message.error('复制失败,请手动选择文本');
      }
      document.body.removeChild(ta);
    }
  }
};
</script>

<style lang="scss" scoped>
.ai-check-item-page {
  padding: 20px;
  background: #fff;
  min-height: 100%;

  /* .page-header 已抽到 PageHeader 组件 */

  .batch-bar {
    margin-bottom: 10px;
    padding: 8px 12px;
    background: #ecf5ff;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 13px;
    color: #409EFF;
  }

  .pagination-wrap {
    margin-top: 16px;
    text-align: right;
  }

  .prompt-pre {
    background: #2d2d2d;
    color: #d4d4d4;
    padding: 14px;
    border-radius: 6px;
    max-height: 480px;
    overflow: auto;
    font-family: Consolas, Monaco, monospace;
    font-size: 12px;
    line-height: 1.6;
    white-space: pre-wrap;
    word-break: break-all;
  }
}
</style>
